import { useContext } from 'react';
import { ReducedFiltersContext } from '../Context';

export default function useReducedFilterState() {
  return useContext(ReducedFiltersContext);
}

export { useReducedFilterState };